<template>
    <div class="pv">

        <!-- ════════════════════ DASHBOARD HEADER ════════════════════ -->
        <div class="pv-dash-header">
            <div class="pv-dash-header-top">
                <div>
                    <div class="pv-eyebrow">TALLER · VERO PRODUCTION</div>
                    <h1 class="pv-title">Pedidos Taller Vero</h1>
                </div>
                <div class="pv-header-actions">
                    <div class="pv-stat-pill">
                        <i class="fa-solid fa-list-check"></i>
                        <strong>{{ pedidosTabla.length }}</strong>
                        <span>pedidos</span>
                    </div>
                    <button class="pv-btn pv-btn--ghost" @click="$router.push('/pedido-taller-vero/progreso-corte')">
                        <i class="fa-solid fa-scissors"></i>
                        <span>Corte</span>
                    </button>
                    <button class="pv-btn pv-btn--ghost" @click="$router.push('/pedido-taller-vero/progreso-mano')">
                        <i class="fa-solid fa-warehouse"></i>
                        <span>Almacén</span>
                    </button>
                    <button class="pv-btn pv-btn--primary" @click="nuevoPedido()">
                        <i class="fa-solid fa-plus"></i>
                        <span>Nuevo pedido</span>
                    </button>
                </div>
            </div>

            <div class="pv-kpis">
                <div class="pv-kpi pv-kpi--listo" v-b-tooltip.hover.bottom title="Terminados en almacén y sin enviar">
                    <div class="pv-kpi-label">
                        <i class="fa-solid fa-box-open"></i>
                        <span>Listos para albarán</span>
                    </div>
                    <div class="pv-kpi-value">
                        <strong>{{ kpisAlbaran.listos.skus }}</strong>
                        <span>SKUs · {{ kpisAlbaran.listos.uds }} uds</span>
                    </div>
                </div>
                <div class="pv-kpi pv-kpi--falta" v-b-tooltip.hover.bottom title="Pedido pero aún sin terminar en almacén">
                    <div class="pv-kpi-label">
                        <i class="fa-solid fa-hourglass-half"></i>
                        <span>Esperando fabricación</span>
                    </div>
                    <div class="pv-kpi-value">
                        <strong>{{ kpisAlbaran.faltan.skus }}</strong>
                        <span>SKUs · {{ kpisAlbaran.faltan.uds }} uds</span>
                    </div>
                </div>
            </div>
        </div>

        <!-- ════════════════════ TABLE CARD ════════════════════ -->
        <section class="pv-card">
            <header class="pv-card-head">
                <div class="pv-card-title">
                    <span class="pv-chevron">›</span>
                    <span>Listado de pedidos</span>
                </div>
                <div class="pv-header-actions">
                <button class="pv-btn pv-btn--ghost" @click="mostrarTerminados = !mostrarTerminados">
                    <i :class="mostrarTerminados ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'"></i>
                    <span>{{ mostrarTerminados ? 'Ocultar terminados' : 'Ver terminados' }}</span>
                </button>
                <div class="pv-search">
                    <i class="fa-solid fa-magnifying-glass pv-search-icon"></i>
                    <input
                        type="text"
                        placeholder="Buscar por código, company, estado o SKU..."
                        v-model="buscar"
                    />
                    <button v-if="buscar" class="pv-search-clear" @click="buscar = ''">
                        <i class="fa-solid fa-xmark"></i>
                    </button>
                </div>
                </div>
            </header>

            <!-- Tabla Principal -->
            <b-table
                :items="pedidosTabla"
                :fields="columnasTable"
                class="table-pedidos"
                hover
                responsive
                sort-icon-left
                @sort-changed="sortChanged"
                show-empty
                empty-text="No hay pedidos"
                :busy="cargandoPedidos"
            >
                <template #table-busy>
                    <div class="text-center text-muted my-3">
                        <b-spinner small class="mr-1"></b-spinner>
                        <span>Cargando pedidos...</span>
                    </div>
                </template>
                <template #cell(options)="data">
                    <div class="action-buttons">
                        <span @click="data.toggleDetails" class="action-btn action-btn-details" :class="{ 'active': data.detailsShowing }">
                            <i :class="data.detailsShowing ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
                        </span>
                        <span @click="imprimirPedido(data.item)" class="action-btn action-btn-print" v-b-tooltip.hover.top title="Imprimir pedido">
                            <i class="fa-solid fa-print"></i>
                        </span>
                        <span @click="copiarTablaPedido(data.item)" class="action-btn action-btn-copy" v-b-tooltip.hover.top title="Copiar tabla (Excel)">
                            <i class="fa-solid fa-table"></i>
                        </span>
                        <span
                            @click="pedidoStats(data.item).pendAlbaran > 0 && enviarAlbaran(data.item)"
                            class="action-btn action-btn-albaran"
                            :class="{ 'is-disabled': pedidoStats(data.item).pendAlbaran === 0 }"
                            v-b-tooltip.hover.top
                            :title="pedidoStats(data.item).pendAlbaran > 0 ? 'Enviar a albarán (' + pedidoStats(data.item).pendAlbaran + ' uds listas)' : 'Nada listo para enviar a albarán'">
                            <i class="fa-solid fa-file-export"></i>
                        </span>
                        <span @click="verHistorial(data.item)" class="action-btn" v-b-tooltip.hover.top title="Historial del pedido">
                            <i class="fa-solid fa-clock-rotate-left"></i>
                        </span>
                        <span @click="abrirComentarios(data.item)" class="action-btn action-btn-comment" :class="{ 'has-comments': data.item.comentarios }" v-b-tooltip.hover.top :title="data.item.comentarios ? 'Ver / editar comentarios' : 'Añadir comentarios'">
                            <i :class="data.item.comentarios ? 'fa-solid fa-comment-dots' : 'fa-regular fa-comment'"></i>
                        </span>
                    </div>
                </template>

                <template #cell(codigo)="data">
                    <span class="codigo-pedido">{{ data.item.codigo }}</span>
                </template>

                <template #cell(company)="data">
                    <span class="company-cell" @click="abrirEditarCompany(data.item)" v-b-tooltip.hover title="Editar company">
                        <span v-if="data.item.company" class="company-pedido">{{ data.item.company }}</span>
                        <span v-else class="text-muted company-add"><i class="fa-solid fa-plus"></i> Company</span>
                        <i class="fa-solid fa-pen company-edit-icon"></i>
                    </span>
                </template>

                <template #cell(fecha)="data">
                    <div class="fecha-cell">
                        <span class="fecha-pedido">{{ data.item.fecha }}</span>
                        <span class="fecha-relativa" :class="ageClass(data.item.fecha)">{{ formatFechaRelativa(data.item.fecha) }}</span>
                    </div>
                </template>

                <template #cell(refs)="data">
                    <span class="refs-pill">
                        <i class="fa-solid fa-shapes"></i>
                        {{ pedidoStats(data.item).refs }}
                    </span>
                </template>

                <template #cell(total)="data">
                    <span class="total-uds">
                        <strong>{{ pedidoStats(data.item).total }}</strong>
                        <span>uds</span>
                    </span>
                </template>

                <template #cell(fabricadas)="data">
                    <span class="total-uds total-uds--ok">
                        <strong>{{ pedidoStats(data.item).fabricadas }}</strong>
                        <span>uds</span>
                    </span>
                </template>

                <template #cell(pendFab)="data">
                    <span class="total-uds" :class="{ 'total-uds--warn': pedidoStats(data.item).pendFab > 0 }">
                        <strong>{{ pedidoStats(data.item).pendFab }}</strong>
                        <span>uds</span>
                    </span>
                </template>

                <template #cell(progreso)="data">
                    <div class="prog-cell">
                        <div class="prog-row">
                            <span class="prog-label">
                                <i class="fa-solid fa-scissors"></i>
                                <span>Corte</span>
                            </span>
                            <div class="prog-bar prog-bar--corte">
                                <div class="prog-bar-fill" :style="{ width: pedidoStats(data.item).corteP + '%' }"></div>
                            </div>
                            <span class="prog-pct">{{ pedidoStats(data.item).corteP }}%</span>
                        </div>
                        <div class="prog-row">
                            <span class="prog-label">
                                <i class="fa-solid fa-warehouse"></i>
                                <span>Almacén</span>
                            </span>
                            <div class="prog-bar prog-bar--mano">
                                <div class="prog-bar-fill" :style="{ width: pedidoStats(data.item).manoP + '%' }"></div>
                            </div>
                            <span class="prog-pct">{{ pedidoStats(data.item).manoP }}%</span>
                        </div>
                        <div class="prog-row" v-b-tooltip.hover.left :title="pedidoStats(data.item).pendAlbaran + ' de ' + pedidoStats(data.item).completados + ' uds completadas sin enviar a albarán'">
                            <span class="prog-label">
                                <i class="fa-solid fa-file-export"></i>
                                <span>Albarán</span>
                            </span>
                            <div class="prog-bar prog-bar--albaran">
                                <div class="prog-bar-fill" :style="{ width: pedidoStats(data.item).albaranP + '%' }"></div>
                            </div>
                            <span class="prog-pct">{{ pedidoStats(data.item).albaranP }}%</span>
                        </div>
                    </div>
                </template>

                <template #cell(estado)="data">
                    <span class="estado-badge" :class="'estado-' + getEstadoClass(data.item.estado)">
                        <i :class="getEstadoIcon(data.item.estado)"></i>
                        {{ data.item.estado }}
                    </span>
                </template>

                <template #cell(options2)="data">
                    <span class="action-btn action-btn-delete" @click="borrarPedido(data.item.id)">
                        <i class="fa-solid fa-trash"></i>
                    </span>
                </template>

                <template #row-details="row">
                    <div class="details-card">
                        <div class="details-header">
                            <h6><i class="fa-solid fa-list-check mr-1"></i> Desglose de Fabricación</h6>
                            <span class="items-count">{{ row.item.listaItems.length }} items · {{ row.item.listaItems.reduce(function(sum, i) { return sum + (i.cantidadTotal || 0) }, 0) }} uds</span>
                        </div>
                        <div class="details-table-wrapper">
                        <b-table
                            :items="agruparItemsPorRaiz(row.item.listaItems)"
                            :fields="getColumnasColores(row.item.listaItems)"
                            class="table-detalle-colores"
                            small
                            bordered
                            sticky-header="600px"
                        >
                            <template #cell(sku)="data">
                                <div class="sku-cell">
                                    <span class="sku-name">{{ getNombreProducto(data.item.sku) }}</span>
                                    <span class="sku-code">{{ data.item.sku }}</span>
                                </div>
                            </template>

                            <template v-for="col in getColumnasColores(row.item.listaItems).filter(c => c.key.startsWith('color_'))"
                                #[`cell(${col.key})`]="data">
                                <div :key="col.key" class="cell-color" :class="{ 'sku-match': coincideSku(data.item[col.key].sku), 'is-terminado': data.item[col.key].terminado, 'is-pendiente': !data.item[col.key].terminado }" v-if="data.item[col.key]">
                                    <div class="color-total" v-if="editandoCantidad !== data.item[col.key].id" @click="iniciarEdicionCantidad(data.item[col.key])">
                                        {{ data.item[col.key].total }}
                                        <i class="fa-solid fa-pen edit-icon-hint"></i>
                                    </div>
                                    <div class="color-total editing" v-else>
                                        <b-form-input
                                            type="number"
                                            v-model.number="cantidadEditando"
                                            size="sm"
                                            class="input-cantidad-edit"
                                            @keyup.enter="guardarCantidad(data.item[col.key])"
                                            @keyup.esc="cancelarEdicionCantidad"
                                            @blur="guardarCantidad(data.item[col.key])"
                                            :min="0"
                                            ref="inputCantidad"
                                        />
                                    </div>
                                    <div class="color-progreso">
                                        <span class="progreso-corte-mini" :title="'Corte: ' + data.item[col.key].corte">
                                            <i class="fa-solid fa-scissors"></i> {{ data.item[col.key].corte }}
                                        </span>
                                        <span class="progreso-mano-mini" :title="'Almacén: ' + data.item[col.key].mano">
                                            <i class="fa-solid fa-warehouse"></i> {{ data.item[col.key].mano }}
                                        </span>
                                    </div>
                                    <div class="color-estado" @click="toggleTerminado(data.item[col.key])" style="cursor: pointer;" v-b-tooltip.hover :title="data.item[col.key].terminado ? 'Desmarcar terminado' : 'Marcar como terminado'">
                                        <i v-if="data.item[col.key].terminado" class="fa-solid fa-circle-check text-success"></i>
                                        <i v-else class="fa-regular fa-circle estado-pendiente-icon"></i>
                                    </div>
                                    <div class="color-delete">
                                        <span class="action-btn-delete-item" @click="borrarItem(data.item[col.key].id, data.item.sku + '-' + col.key.replace('color_','').toUpperCase())" v-b-tooltip.hover title="Eliminar SKU">
                                            <i class="fa-solid fa-xmark"></i>
                                        </span>
                                    </div>
                                </div>
                            </template>
                        </b-table>
                        </div>
                    </div>
                </template>
            </b-table>
        </section>

        <!-- Modal Albarán -->
        <b-modal
            id="modal-albaran"
            ref="modal-albaran"
            size="lg"
            centered
            modal-class="modal-albaran"
        >
            <template #modal-header>
                <div class="modal-header-custom">
                    <h5><i class="fa-solid fa-file-export mr-2"></i>Enviar a Albarán</h5>
                    <span class="codigo-badge" v-if="pedidoAlbaran">{{ pedidoAlbaran.codigo }}</span>
                </div>
            </template>

            <div class="albaran-info mb-3">
                <small class="text-muted">Selecciona los productos y cantidades a enviar al albarán</small>
            </div>

            <b-table
                :items="itemsDisponiblesAlbaran"
                :fields="columnasAlbaran"
                class="table-albaran"
                small
                hover
            >
                <template #cell(seleccionar)="data">
                    <b-form-checkbox v-model="data.item.seleccionado" @change="onSeleccionChange(data.item)" />
                </template>
                <template #cell(sku)="data">
                    <div class="sku-cell">
                        <span class="sku-name">{{ getNombreProducto(data.item.sku) }}</span>
                        <span class="sku-code">{{ data.item.sku }}</span>
                    </div>
                </template>
                <template #cell(cantidadTotal)="data">
                    <span class="text-muted">{{ data.item.cantidadTotal }}</span>
                </template>
                <template #cell(disponible)="data">
                    <span class="disponible-badge">{{ data.item.disponible }}</span>
                    <small class="text-muted ml-1">(de {{ data.item.disponibleBase }} terminadas)</small>
                </template>
                <template #cell(cantidadEnviar)="data">
                    <b-form-input
                        type="number"
                        v-model.number="data.item.cantidadEnviar"
                        :min="0"
                        size="sm"
                        class="input-cantidad"
                        :class="{ 'input-excedido': data.item.seleccionado && data.item.cantidadEnviar > data.item.disponible }"
                        :disabled="!data.item.seleccionado"
                    />
                    <small v-if="data.item.seleccionado && data.item.cantidadEnviar > data.item.disponible" class="aviso-excedido">
                        <i class="fa-solid fa-triangle-exclamation"></i>
                        +{{ data.item.cantidadEnviar - data.item.disponible }} sobre lo disponible
                    </small>
                </template>
            </b-table>

            <template #modal-footer>
                <div class="modal-footer-custom">
                    <span class="resumen-envio" v-if="totalItemsSeleccionados > 0">
                        {{ totalItemsSeleccionados }} items, {{ totalUnidadesSeleccionadas }} unidades
                    </span>
                    <div class="footer-buttons">
                        <b-button variant="outline-secondary" size="sm" @click="$refs['modal-albaran'].hide()">
                            Cancelar
                        </b-button>
                        <b-button variant="primary" size="sm" @click="confirmarEnvioAlbaran" :disabled="totalItemsSeleccionados === 0">
                            <i class="fa-solid fa-paper-plane mr-1"></i> Enviar Seleccionados
                        </b-button>
                    </div>
                </div>
            </template>
        </b-modal>

        <!-- Modal Historial -->
        <b-modal
            id="modal-historial"
            ref="modal-historial"
            size="lg"
            hide-footer
            centered
            modal-class="modal-historial"
        >
            <template #modal-header>
                <div class="modal-header-custom">
                    <h5><i class="fa-solid fa-clock-rotate-left mr-2"></i>Historial</h5>
                    <span class="sku-badge" v-if="itemHistorial">{{ itemHistorial.codigo }}</span>
                    <b-form-input
                        v-model="buscarHistorial"
                        placeholder="Buscar producto, SKU o sección..."
                        size="sm"
                        class="buscar-historial ml-auto"
                    />
                </div>
            </template>

            <div v-if="historialCargando" class="text-center py-4">
                <b-spinner variant="primary"></b-spinner>
                <p class="mt-2 text-muted">Cargando historial...</p>
            </div>

            <b-table
                v-else-if="historialFiltrado.length > 0"
                :items="historialFiltrado"
                :fields="columnasHistorial"
                class="table-historial"
                sticky-header="calc(100vh - 200px)"
                small
                hover
            >
                <template #cell(fecha)="data">
                    <span class="fecha-historial">{{ formatearFecha(data.item.fecha) }}</span>
                </template>
                <template #cell(sku)="data">
                    <div class="sku-cell">
                        <span class="sku-name">{{ getNombreProducto(data.item.sku) }}</span>
                        <span class="sku-code">{{ data.item.sku }}</span>
                    </div>
                </template>
                <template #cell(columna)="data">
                    <span class="seccion-badge" :class="data.item.columna === 'cantidadCorte' ? 'seccion-corte' : 'seccion-aparado'">
                        {{ seccionHistorial[data.item.columna] || data.item.columna }}
                    </span>
                </template>
                <template #cell(cantidad)="data">
                    <span v-if="data.item.columna === 'cantidadCorte' || data.item.columna === 'cantidadMano'" class="incremento">{{ data.item.cantidad > 0 ? '+' : '' }}{{ data.item.cantidad }}</span>
                </template>
            </b-table>

            <div v-else class="empty-historial">
                <i class="fa-solid fa-inbox"></i>
                <p>{{ historialData.length ? 'Ningún movimiento coincide con la búsqueda' : 'No hay historial para este pedido' }}</p>
            </div>
        </b-modal>

        <b-modal
            id="modal-company"
            ref="modal-company"
            centered
            title="Editar Company"
            ok-title="Guardar"
            cancel-title="Cancelar"
            :ok-disabled="guardandoCompany"
            @ok.prevent="guardarCompany"
        >
            <div v-if="pedidoCompany">
                <p class="mb-1 text-muted">Pedido <b>{{ pedidoCompany.codigo }}</b></p>
                <b-form-input
                    v-model="companyEdit"
                    placeholder="Company / Cliente"
                    autofocus
                    @keyup.enter="guardarCompany"
                />
            </div>
        </b-modal>

        <b-modal
            id="modal-comentarios"
            ref="modal-comentarios"
            centered
            title="Comentarios del pedido"
            ok-title="Guardar"
            cancel-title="Cancelar"
            :ok-disabled="guardandoComentarios"
            @ok.prevent="guardarComentarios"
        >
            <div v-if="pedidoComentarios">
                <p class="mb-1 text-muted">Pedido <b>{{ pedidoComentarios.codigo }}</b></p>
                <b-form-textarea
                    v-model="comentariosEdit"
                    placeholder="Escribe aquí las notas o comentarios del pedido..."
                    rows="5"
                    max-rows="12"
                    autofocus
                />
            </div>
        </b-modal>
    </div>
</template>

<script>
import axios from '@axios'
import { BTable, BFormInput, BFormTextarea, BFormGroup, BBadge, BCard, BModal, BSpinner, BFormCheckbox, BButton, VBTooltip } from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code'

export default {
    components: { BCardCode, BTable, BFormInput, BFormTextarea, BFormGroup, BBadge, BCard, BModal, BSpinner, BFormCheckbox, BButton },
    directives: { 'b-tooltip': VBTooltip },
    data() {
        return {
            columnasTable: [
                { key: "options", label: "", thStyle: { width: "130px" } },
                { key: "codigo", label: "Pedido", sortable: true },
                { key: "company", label: "Company", sortable: true },
                { key: "fecha", label: "Fecha", sortable: true },
                { key: "refs", label: "Refs", sortable: true, thStyle: { width: "90px" } },
                { key: "total", label: "Total", sortable: true, thStyle: { width: "100px" } },
                { key: "fabricadas", label: "Fabricadas", thStyle: { width: "110px" } },
                { key: "pendFab", label: "Pendientes", thStyle: { width: "110px" } },
                { key: "progreso", label: "Progreso", thStyle: { width: "260px" } },
                { key: "estado", label: "Estado", sortable: true, thStyle: { width: "130px" } },
                { key: "options2", label: "", thStyle: { width: "60px" } },
            ],
            columnasDetalleItems: [
                { key: "sku", label: "Producto", thStyle: { width: "35%" } },
                { key: "cantidadTotal", label: "Total", thStyle: { width: "10%" } },
                { key: "progreso", label: "Progreso", thStyle: { width: "35%" } },
                { key: "terminado", label: "", thStyle: { width: "10%" } },
                { key: "historial", label: "", thStyle: { width: "10%" } },
            ],
            columnasHistorial: [
                { key: "fecha", label: "Fecha", sortable: true },
                { key: "sku", label: "Producto" },
                { key: "columna", label: "Sección" },
                { key: "cantidad", label: "Incremento" },
            ],
            buscar: "",
            listadoPedidos: [],
            pedidosBusqueda: [],
            mostrarTerminados: false,
            cargandoPedidos: true,
            lastSort: null,
            skuTitulos: {},
            itemHistorial: null,
            buscarHistorial: '',
            seccionHistorial: { cantidadCorte: 'CORTE', cantidadMano: 'ALMACÉN', pausa: 'PAUSA', reanudado: 'REANUDADO' },
            historialData: [],
            historialCargando: false,
            // Edición de cantidad
            editandoCantidad: null,
            cantidadEditando: 0,
            // Modal Albarán
            pedidoAlbaran: null,
            itemsDisponiblesAlbaran: [],
            columnasAlbaran: [
                { key: "seleccionar", label: "", thStyle: { width: "50px" } },
                { key: "sku", label: "Producto" },
                { key: "cantidadTotal", label: "Pedido" },
                { key: "disponible", label: "Disponible" },
                { key: "cantidadEnviar", label: "Cantidad a Enviar", thStyle: { width: "150px" } },
            ],
            // Edición de company
            pedidoCompany: null,
            companyEdit: "",
            guardandoCompany: false,
            // Edición de comentarios
            pedidoComentarios: null,
            comentariosEdit: "",
            guardandoComentarios: false,
        }
    },
    computed: {
        historialFiltrado() {
            const q = this.buscarHistorial.trim().toLowerCase();
            if (!q) return this.historialData;
            return this.historialData.filter(h =>
                (h.sku || '').toLowerCase().includes(q) ||
                this.getNombreProducto(h.sku || '').toLowerCase().includes(q) ||
                (this.seccionHistorial[h.columna] || h.columna || '').toLowerCase().includes(q)
            );
        },
        // Los terminados se ocultan por defecto; los KPIs siguen usando pedidosBusqueda
        // para no perder lo pendiente de albarán de pedidos ya terminados
        pedidosTabla() {
            if (this.mostrarTerminados) return this.pedidosBusqueda;
            return this.pedidosBusqueda.filter(p => p.estado !== 'Terminado');
        },
        // KPIs de albarán sobre los pedidos listados (SKUs distintos + uds)
        kpisAlbaran() {
            const listos = {};
            const faltan = {};
            this.pedidosBusqueda.forEach(pedido => {
                (pedido.listaItems || []).forEach(i => {
                    const total = Number(i.cantidadTotal) || 0;
                    const enviado = Number(i.cantidadAlbaran) || 0;
                    const hecho = i.terminado ? total : (Number(i.cantidadMano) || 0);
                    const pendListo = Math.max(this.listoAlbaran(i) - enviado, 0);
                    // Lo que aún no está hecho (ni enviado): esperando fabricación
                    const pendFab = Math.max(total - Math.max(hecho, enviado), 0);
                    if (pendListo > 0) listos[i.sku] = (listos[i.sku] || 0) + pendListo;
                    if (pendFab > 0) faltan[i.sku] = (faltan[i.sku] || 0) + pendFab;
                });
            });
            const resumen = obj => ({
                skus: Object.keys(obj).length,
                uds: Object.values(obj).reduce((s, n) => s + n, 0),
            });
            return { listos: resumen(listos), faltan: resumen(faltan) };
        },
        totalItemsSeleccionados() {
            return this.itemsDisponiblesAlbaran.filter(item => item.seleccionado && item.cantidadEnviar > 0).length;
        },
        totalUnidadesSeleccionadas() {
            return this.itemsDisponiblesAlbaran
                .filter(item => item.seleccionado && item.cantidadEnviar > 0)
                .reduce((sum, item) => sum + (item.cantidadEnviar || 0), 0);
        }
    },
    methods: {
        async loadItems() {
            try {
                axios.post("/uso", { seccion: "pedidosVero-listado" });

                const resTitulos = await axios.get("/sku/title");
                resTitulos.data.forEach(item => {
                    this.skuTitulos[item.skuSingle] = item.productTitle;
                });

                const tipo = (this.$route.meta && this.$route.meta.tipo) || 'B2C';
                const response = await axios.get("/taller/pedido/vero", { params: { tipo } });
                const pedidos = response.data;

                await Promise.all(pedidos.map(async pedido => {
                    const resItems = await axios.get(`/taller/pedido/vero/items/${pedido.id}`);
                    pedido.listaItems = resItems.data;
                }));

                this.listadoPedidos = pedidos;
                this.buscarFuncion();
            } catch (error) {
                console.error("Error cargando pedidos:", error);
            } finally {
                this.cargandoPedidos = false;
            }
        },
        getVariantEstado(estado) {
            if (estado === 'Terminado') return 'success';
            if (estado === 'En proceso') return 'warning';
            return 'light';
        },
        getEstadoClass(estado) {
            if (estado === 'Terminado') return 'terminado';
            if (estado === 'En proceso') return 'proceso';
            return 'pendiente';
        },
        getEstadoIcon(estado) {
            if (estado === 'Terminado') return 'fa-solid fa-check-circle';
            if (estado === 'En proceso') return 'fa-solid fa-spinner';
            return 'fa-solid fa-circle';
        },
        getProgresoPorcentaje(actual, total) {
            if (!total) return 0;
            return Math.min((actual / total) * 100, 100);
        },
        // ════ Métricas agregadas por pedido ════
        // Uds listas para albarán: lo que hay en almacén; si está marcado como
        // terminado y almacén está a 0, se usa lo cortado.
        listoAlbaran(item) {
            const mano = Number(item.cantidadMano) || 0;
            if (item.terminado && mano === 0) return Number(item.cantidadCorte) || 0;
            return mano;
        },
        pedidoStats(pedido) {
            if (!pedido || !pedido.listaItems || pedido.listaItems.length === 0) {
                return { refs: 0, total: 0, fabricadas: 0, pendFab: 0, corte: 0, mano: 0, corteP: 0, manoP: 0, completados: 0, pendAlbaran: 0, albaranP: 0 };
            }
            const items = pedido.listaItems;
            const total = items.reduce(function(s, i) { return s + (Number(i.cantidadTotal) || 0); }, 0);
            const corte = items.reduce(function(s, i) { return s + (Number(i.cantidadCorte) || 0); }, 0);
            // Un SKU marcado como terminado cuenta como completo en almacén
            const mano  = items.reduce(function(s, i) {
                return s + (i.terminado ? (Number(i.cantidadTotal) || 0) : (Number(i.cantidadMano) || 0));
            }, 0);
            // Pendiente de albarán: listo (ver listoAlbaran) que no se ha enviado
            const completados = mano;
            const pendAlbaran = items.reduce(function(s, i) {
                return s + Math.max(this.listoAlbaran(i) - (Number(i.cantidadAlbaran) || 0), 0);
            }.bind(this), 0);
            // Enviado a albarán (sin pasar del total de cada SKU)
            const enviado = items.reduce(function(s, i) {
                return s + Math.min(Number(i.cantidadAlbaran) || 0, Number(i.cantidadTotal) || 0);
            }, 0);
            // Fabricadas: hecho (almacén/terminado) o ya enviado, sin pasar del total de cada SKU.
            // Misma regla que el KPI "Esperando fabricación".
            const fabricadas = items.reduce(function(s, i) {
                const t = Number(i.cantidadTotal) || 0;
                const hecho = i.terminado ? t : (Number(i.cantidadMano) || 0);
                return s + Math.min(Math.max(hecho, Number(i.cantidadAlbaran) || 0), t);
            }, 0);
            return {
                fabricadas: fabricadas,
                pendFab: total - fabricadas,
                completados: completados,
                pendAlbaran: pendAlbaran,
                albaranP: total > 0 ? Math.round((enviado / total) * 100) : 0,
                refs: items.length,
                total: total,
                corte: corte,
                mano: mano,
                corteP: total > 0 ? Math.round((corte / total) * 100) : 0,
                manoP:  total > 0 ? Math.round((mano  / total) * 100) : 0,
            };
        },
        formatFechaRelativa(fecha) {
            if (!fecha) return '—';
            const d = new Date(fecha);
            if (isNaN(d.getTime())) return fecha;
            const ahora = new Date();
            const diffMs = ahora - d;
            const diffDias = Math.floor(diffMs / (1000 * 60 * 60 * 24));
            if (diffDias === 0) return 'hoy';
            if (diffDias === 1) return 'ayer';
            if (diffDias < 7)   return 'hace ' + diffDias + ' días';
            if (diffDias < 30)  return 'hace ' + Math.floor(diffDias / 7) + ' sem';
            if (diffDias < 365) return 'hace ' + Math.floor(diffDias / 30) + ' meses';
            return 'hace ' + Math.floor(diffDias / 365) + ' años';
        },
        diasDesde(fecha) {
            if (!fecha) return 0;
            const d = new Date(fecha);
            if (isNaN(d.getTime())) return 0;
            return Math.floor((new Date() - d) / (1000 * 60 * 60 * 24));
        },
        ageClass(fecha) {
            const dias = this.diasDesde(fecha);
            if (dias < 7) return 'age-fresh';
            if (dias < 15) return 'age-warn';
            return 'age-stale';
        },
        getNombreProducto(sku) {
            // En la tabla agrupada el sku ya es la raíz (sin color)
            if (this.skuTitulos[sku]) return this.skuTitulos[sku];
            const lastDash = sku.lastIndexOf('-');
            const raiz = sku.substring(0, lastDash);
            return this.skuTitulos[raiz] || raiz;
        },
        agruparItemsPorRaiz(items) {
            if (!items || items.length === 0) return [];

            const grupos = {};

            items.forEach(item => {
                const lastDash = item.sku.lastIndexOf('-');
                const raiz = item.sku.substring(0, lastDash);
                const color = item.sku.substring(lastDash + 1).toLowerCase();

                if (!grupos[raiz]) {
                    grupos[raiz] = { sku: raiz };
                }

                grupos[raiz][`color_${color}`] = {
                    total: item.cantidadTotal,
                    corte: item.cantidadCorte,
                    mano: item.cantidadMano,
                    terminado: item.terminado,
                    id: item.id,
                    sku: item.sku
                };
            });

            return Object.values(grupos);
        },
        // Orden fijo de colores (el mismo en la tabla en pantalla y en el PDF);
        // los colores no listados van al final por orden alfabético.
        ordenarColores(colores) {
            const ordenColores = ['tan', 'black', 'blk', 'db', 'navy', 'grey', 'mocha', 'olive', 'camel', 'caoba', 'brown', 'army', 'amber', 'stone', 'hab', 'khaki', 'khk'];
            return colores.slice().sort((a, b) => {
                const la = String(a).toLowerCase();
                const lb = String(b).toLowerCase();
                const indexA = ordenColores.indexOf(la);
                const indexB = ordenColores.indexOf(lb);
                if (indexA === -1 && indexB === -1) return la.localeCompare(lb);
                if (indexA === -1) return 1;
                if (indexB === -1) return -1;
                return indexA - indexB;
            });
        },
        getColumnasColores(items) {
            if (!items || items.length === 0) return [];

            const coloresSet = new Set();

            items.forEach(item => {
                const lastDash = item.sku.lastIndexOf('-');
                const color = item.sku.substring(lastDash + 1).toLowerCase();
                coloresSet.add(color);
            });

            const colores = this.ordenarColores(Array.from(coloresSet));

            const columnas = [
                { key: "sku", label: "Producto", stickyColumn: true, thStyle: { width: "180px" } }
            ];

            colores.forEach(color => {
                columnas.push({
                    key: `color_${color}`,
                    label: color.toUpperCase(),
                    thStyle: { width: "80px", textAlign: "center" }
                });
            });

            return columnas;
        },
        coincideSku(sku) {
            return !!this.buscar && (sku || '').toLowerCase().includes(this.buscar.toLowerCase());
        },
        buscarFuncion() {
            const query = this.buscar.toLowerCase();
            this.pedidosBusqueda = this.listadoPedidos.filter(p =>
                p.codigo.toLowerCase().includes(query) ||
                p.estado.toLowerCase().includes(query) ||
                (p.company || '').toLowerCase().includes(query) ||
                (p.listaItems || []).some(i => (i.sku || '').toLowerCase().includes(query))
            );
        },
        abrirEditarCompany(pedido) {
            this.pedidoCompany = pedido;
            this.companyEdit = pedido.company || '';
            this.$refs['modal-company'].show();
        },
        async guardarCompany() {
            if (!this.pedidoCompany) return;
            this.guardandoCompany = true;
            const company = this.companyEdit.trim();
            try {
                await axios.put("/taller/pedido/vero/company", { id: this.pedidoCompany.id, company });
                // Actualiza en local para reflejarlo sin recargar
                this.pedidoCompany.company = company;
                const enLista = this.listadoPedidos.find(p => p.id === this.pedidoCompany.id);
                if (enLista) enLista.company = company;
                this.buscarFuncion();
                this.$refs['modal-company'].hide();
                this.$bvToast.toast('Company actualizada', { title: 'Pedidos', variant: 'success', solid: true });
            } catch (e) {
                this.$bvToast.toast('Error al guardar la company', { title: 'Pedidos', variant: 'danger', solid: true });
            } finally {
                this.guardandoCompany = false;
            }
        },
        abrirComentarios(pedido) {
            this.pedidoComentarios = pedido;
            this.comentariosEdit = pedido.comentarios || '';
            this.$refs['modal-comentarios'].show();
        },
        async guardarComentarios() {
            if (!this.pedidoComentarios) return;
            this.guardandoComentarios = true;
            const comentarios = this.comentariosEdit.trim();
            try {
                await axios.put("/taller/pedido/vero/comentarios", { id: this.pedidoComentarios.id, comentarios });
                // Actualiza en local para reflejarlo sin recargar
                this.pedidoComentarios.comentarios = comentarios;
                const enLista = this.listadoPedidos.find(p => p.id === this.pedidoComentarios.id);
                if (enLista) enLista.comentarios = comentarios;
                this.$refs['modal-comentarios'].hide();
                this.$bvToast.toast('Comentarios guardados', { title: 'Pedidos', variant: 'success', solid: true });
            } catch (e) {
                this.$bvToast.toast('Error al guardar los comentarios', { title: 'Pedidos', variant: 'danger', solid: true });
            } finally {
                this.guardandoComentarios = false;
            }
        },
        nuevoPedido() {
            const tipo = (this.$route.meta && this.$route.meta.tipo) || 'B2C';
            const ruta = tipo === 'B2B' ? '/pedido-taller-vero-b2b/nuevo' : '/pedido-taller-vero/nuevo';
            this.$router.push(ruta);
        },
        borrarItem(itemId, skuLabel) {
            this.$swal({
                title: `¿Eliminar ${skuLabel}?`,
                text: 'Se eliminará este SKU del pedido',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar',
                customClass: { confirmButton: 'btn btn-danger', cancelButton: 'btn btn-outline-secondary ml-1' },
                buttonsStyling: false,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const res = await axios.delete(`/taller/pedido/vero/item/${itemId}`);
                        // Pedido al que pertenece el item borrado
                        const pedido = this.listadoPedidos.find(p =>
                            (p.listaItems || []).some(i => i.id === itemId)
                        );
                        if (res.data.pedidoVacio) {
                            // Se quedó sin items: se oculta en servidor → lo quitamos de la lista
                            if (pedido) {
                                this.listadoPedidos = this.listadoPedidos.filter(p => p.id !== pedido.id);
                                this.buscarFuncion();
                            }
                            this.$swal({ icon: 'info', title: 'Pedido vaciado', text: 'El pedido se ha ocultado porque no le quedan items' });
                        } else if (pedido) {
                            // Refrescamos solo los items de este pedido, sin cerrar el desglose
                            const resItems = await axios.get(`/taller/pedido/vero/items/${pedido.id}`);
                            this.$set(pedido, 'listaItems', resItems.data);
                        } else {
                            this.loadItems();
                        }
                    } catch (error) {
                        console.error('Error al eliminar item:', error);
                        this.$swal({ icon: 'error', title: 'Error', text: 'No se pudo eliminar el item' });
                    }
                }
            });
        },
        borrarPedido(id) {
            this.$swal({
                title: '¿Ocultar este pedido?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, ocultar',
                customClass: { confirmButton: 'btn btn-primary', cancelButton: 'btn btn-outline-danger ml-1' },
                buttonsStyling: false,
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await axios.delete("/taller/pedido/vero/ocultar", { data: { id } });
                    this.loadItems();
                }
            });
        },
        sortChanged(e) {
            this.lastSort = e;
        },
        imprimirPedido(pedido) {
            const printWindow = window.open('', '_blank', '');

            const productos = {};
            const coloresSet = new Set();

            if (pedido.listaItems && pedido.listaItems.length > 0) {
                pedido.listaItems.forEach(item => {
                    const lastDash = item.sku.lastIndexOf('-');
                    const raiz = item.sku.substring(0, lastDash);
                    const color = item.sku.substring(lastDash + 1).toUpperCase();

                    coloresSet.add(color);

                    if (!productos[raiz]) {
                        const titulo = this.skuTitulos[raiz] || raiz;
                        productos[raiz] = { nombre: titulo, colores: {} };
                    }
                    productos[raiz].colores[color] = item.cantidadTotal;
                });
            }

            const colores = this.ordenarColores(Array.from(coloresSet));
            const headerColores = colores.map(c => `<th>${c}</th>`).join('');

            let filas = '';
            Object.keys(productos).forEach(raiz => {
                const prod = productos[raiz];
                const celdasColores = colores.map(c => {
                    const cantidad = prod.colores[c] || '';
                    return `<td>${cantidad}</td>`;
                }).join('');

                filas += `<tr><td class="producto">${prod.nombre}</td>${celdasColores}<td></td><td></td><td></td></tr>`;
            });

            printWindow.document.write(`
                <html>
                <head>
                    <title>Pedido ${pedido.codigo}</title>
                    <style>
                        body { font-family: Arial, sans-serif; margin: 10px; font-size: 11px; }
                        h2 { margin-bottom: 10px; }
                        table { width: 100%; border-collapse: collapse; }
                        th, td { border: 1px solid #000; padding: 4px; text-align: center; }
                        th { background-color: #f0f0f0; font-weight: bold; }
                        td.producto { text-align: left; white-space: nowrap; }
                        @media print {
                            body { margin: 5px; }
                            @page { size: landscape; }
                        }
                    </style>
                </head>
                <body>
                    <h2>Pedido ${pedido.codigo} ${pedido.fecha}</h2>
                    <table>
                        <thead>
                            <tr>
                                <th></th>
                                ${headerColores}
                                <th>CORTE</th>
                                <th>ALMACÉN</th>
                                <th>FIN</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${filas}
                        </tbody>
                    </table>
                </body>
                </html>
            `);

            printWindow.document.close();
            printWindow.focus();

            printWindow.onload = function() {
                printWindow.print();
                printWindow.close();
            };
        },
        // Copia la tabla del pedido al portapapeles en formato TSV (pegable en
        // Excel): misma estructura que el PDF pero con el SKU raíz en vez del título.
        async copiarTablaPedido(pedido) {
            if (!pedido.listaItems || pedido.listaItems.length === 0) {
                this.$bvToast.toast('El pedido no tiene items', { title: 'Pedidos', variant: 'warning', solid: true });
                return;
            }

            const productos = {};
            const coloresSet = new Set();

            pedido.listaItems.forEach(item => {
                const lastDash = item.sku.lastIndexOf('-');
                const raiz = item.sku.substring(0, lastDash);
                const color = item.sku.substring(lastDash + 1).toUpperCase();
                coloresSet.add(color);
                if (!productos[raiz]) productos[raiz] = {};
                productos[raiz][color] = item.cantidadTotal;
            });

            const colores = this.ordenarColores(Array.from(coloresSet));
            const lineas = [['SKU', ...colores]];
            Object.keys(productos).forEach(raiz => {
                lineas.push([raiz, ...colores.map(c => (productos[raiz][c] != null ? productos[raiz][c] : ''))]);
            });
            const tsv = lineas.map(l => l.join('\t')).join('\n');

            try {
                await navigator.clipboard.writeText(tsv);
            } catch (e) {
                // Fallback para navegadores sin permiso de clipboard API
                const ta = document.createElement('textarea');
                ta.value = tsv;
                document.body.appendChild(ta);
                ta.select();
                document.execCommand('copy');
                document.body.removeChild(ta);
            }
            this.$bvToast.toast(`Tabla del pedido ${pedido.codigo} copiada`, { title: 'Pedidos', variant: 'success', solid: true });
        },
        async verHistorial(pedido) {
            this.itemHistorial = pedido;
            this.buscarHistorial = '';
            this.historialData = [];
            this.historialCargando = true;
            this.$refs['modal-historial'].show();

            try {
                const response = await axios.get(`/taller/pedido/vero/historial/pedido/${pedido.id}`);
                this.historialData = response.data;
            } catch (error) {
                console.error("Error cargando historial:", error);
            } finally {
                this.historialCargando = false;
            }
        },
        formatearFecha(fecha) {
            if (!fecha) return '';
            const d = new Date(fecha);
            const dia = String(d.getDate()).padStart(2, '0');
            const mes = String(d.getMonth() + 1).padStart(2, '0');
            const anio = d.getFullYear();
            const hora = String(d.getHours()).padStart(2, '0');
            const min = String(d.getMinutes()).padStart(2, '0');
            return `${dia}-${mes}-${anio} ${hora}:${min}`;
        },
        enviarAlbaran(pedido) {
            if (!pedido.listaItems || pedido.listaItems.length === 0) {
                this.$swal({
                    icon: 'warning',
                    title: 'Sin items',
                    text: 'Este pedido no tiene items para enviar al albarán',
                });
                return;
            }


            /*v 
            ERP
                Ver historial de pedidos de un material
            */
            

            // Disponible = listo (ver listoAlbaran) - lo ya enviado a albarán.
            const itemsDisponibles = pedido.listaItems
                .map(item => {
                    const base = this.listoAlbaran(item);
                    const disponible = base - (Number(item.cantidadAlbaran) || 0);
                    return { ...item, disponibleBase: base, disponible, cantidadEnviar: disponible, seleccionado: true };
                })
                .filter(item => item.disponible > 0);

            if (itemsDisponibles.length === 0) {
                this.$swal({
                    icon: 'info',
                    title: 'Sin items disponibles',
                    text: 'No hay items con cantidades pendientes de enviar a albarán',
                });
                return;
            }

            this.pedidoAlbaran = pedido;
            this.itemsDisponiblesAlbaran = itemsDisponibles;
            this.$refs['modal-albaran'].show();
        },
        onSeleccionChange(item) {
            if (!item.seleccionado) {
                item.cantidadEnviar = 0;
            } else {
                item.cantidadEnviar = item.disponible;
            }
        },
        async toggleTerminado(colorData) {
            try {
                const res = await axios.put('/taller/pedido/vero/item/terminado', { id: colorData.id });
                colorData.terminado = res.data.terminado;
                // Sincronizar el item original para que se recalcule el % de almacén
                this.listadoPedidos.forEach(function(pedido) {
                    (pedido.listaItems || []).forEach(function(item) {
                        if (item.id === colorData.id) {
                            item.terminado = res.data.terminado;
                            pedido.estado = res.data.estadoPedido;
                        }
                    });
                });
            } catch (error) {
                console.error('Error al cambiar terminado:', error);
                this.$swal({ icon: 'error', title: 'Error', text: 'No se pudo cambiar el estado' });
            }
        },
        iniciarEdicionCantidad(colorData) {
            this.editandoCantidad = colorData.id;
            this.cantidadEditando = colorData.total;
            this.$nextTick(function() {
                var inputs = document.querySelectorAll('.input-cantidad-edit');
                if (inputs.length > 0) {
                    inputs[inputs.length - 1].focus();
                    inputs[inputs.length - 1].select();
                }
            });
        },
        async guardarCantidad(colorData) {
            if (this.editandoCantidad === null) return;
            var nuevaCantidad = this.cantidadEditando;
            if (nuevaCantidad === colorData.total) {
                this.editandoCantidad = null;
                return;
            }
            if (nuevaCantidad < 0) {
                this.editandoCantidad = null;
                return;
            }
            try {
                const res = await axios.put('/taller/pedido/vero/item/cantidad', { id: colorData.id, cantidadTotal: nuevaCantidad });
                colorData.total = nuevaCantidad;
                colorData.terminado = res.data.terminado;
                // Sincronizar el item original para que se recalculen % y estado
                this.listadoPedidos.forEach(function(pedido) {
                    (pedido.listaItems || []).forEach(function(item) {
                        if (item.id === colorData.id) {
                            item.cantidadTotal = nuevaCantidad;
                            item.terminado = res.data.terminado;
                            pedido.estado = res.data.estadoPedido;
                        }
                    });
                });
                this.editandoCantidad = null;
            } catch (error) {
                console.error('Error al actualizar cantidad:', error);
                this.$swal({ icon: 'error', title: 'Error', text: 'No se pudo actualizar la cantidad' });
                this.editandoCantidad = null;
            }
        },
        cancelarEdicionCantidad() {
            this.editandoCantidad = null;
        },
        async confirmarEnvioAlbaran() {
            const itemsAEnviar = this.itemsDisponiblesAlbaran
                .filter(item => item.seleccionado && item.cantidadEnviar > 0);

            if (itemsAEnviar.length === 0) {
                this.$swal({
                    icon: 'warning',
                    title: 'Sin selección',
                    text: 'Selecciona al menos un item para enviar',
                });
                return;
            }

            const today = new Date().toISOString().split('T')[0];

            // 1. Datos para finanzas
            const datosFinanzas = itemsAEnviar.map(item => ({
                sku: item.sku,
                cantidad: item.cantidadEnviar,
                titulo: item.sku,
                fechaTerminado: today,
                finalizado: false
            }));

            // 2. Datos para actualizar cantidadAlbaran
            const datosActualizar = itemsAEnviar.map(item => ({
                id: item.id,
                cantidadEnviar: item.cantidadEnviar
            }));

            try {
                await axios.post("/finanzas/pendiente/multiple/facturar", datosFinanzas);
                await axios.put("/taller/pedido/vero/albaran", { items: datosActualizar });

                this.$refs['modal-albaran'].hide();
                this.loadItems();

                // Preguntar si quiere sumar stock
                const result = await this.$swal({
                    icon: 'question',
                    title: 'Enviado al albaran',
                    html: `Se han enviado <b>${itemsAEnviar.length} productos</b> (${this.totalUnidadesSeleccionadas} uds) al albaran.<br><br>¿Quieres sumar las cantidades al stock de Shopify?`,
                    showCancelButton: true,
                    confirmButtonText: 'Si, sumar stock',
                    cancelButtonText: 'No',
                    confirmButtonColor: '#28c76f',
                });

                if (result.isConfirmed) {
                    const datosStock = itemsAEnviar.map(function(item) {
                        return { sku: item.sku, cantidad: item.cantidadEnviar };
                    });

                    try {
                        var stockRes = await axios.post("/taller/pedido/vero/sumar-stock", { items: datosStock });
                        var resData = stockRes.data;
                        var errores = resData.resultados ? resData.resultados.filter(function(r) { return !r.ok; }) : [];

                        if (errores.length > 0) {
                            var skusFallidos = errores.map(function(e) { return e.sku; }).join(', ');
                            this.$swal({
                                icon: 'warning',
                                title: 'Stock parcialmente actualizado',
                                html: 'No se encontraron en Shopify: <b>' + skusFallidos + '</b>',
                            });
                        } else {
                            this.$swal({
                                icon: 'success',
                                title: 'Stock actualizado',
                                text: 'Se ha sumado el stock en Shopify correctamente',
                            });
                        }
                    } catch (stockError) {
                        console.error(stockError);
                        this.$swal({
                            icon: 'error',
                            title: 'Error',
                            text: 'Error al sumar stock en Shopify',
                        });
                    }
                }
            } catch (error) {
                console.error(error);
                this.$swal({
                    icon: 'error',
                    title: 'Error',
                    text: 'Error al enviar al albaran',
                });
            }
        }
    },
    mounted() {
        this.loadItems();
    },
    watch: {
        buscar() { this.buscarFuncion(); },
        // Al cambiar entre B2C y B2B se reutiliza el componente: recargar datos
        '$route.meta.tipo'() { this.loadItems(); },
    }
}
</script>

<style lang="scss" scoped>
#card-pedidos {
    .card-header { display: none; }
}

// Header
.header-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    padding-bottom: 15px;
    border-bottom: 1px solid #eee;
}

.header-title {
    margin: 0;
    font-weight: 600;
    color: #333;
}

.header-actions {
    display: flex;
    gap: 8px;
}

// Search
.search-section {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.search-box {
    position: relative;
    flex: 1;
    max-width: 400px;
}

.search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
}

.search-input {
    padding-left: 38px;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    &:focus {
        border-color: #7367f0;
        box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.1);
    }
}

.search-stats {
    font-size: 13px;
}

// Table
.table-pedidos {
    border-radius: 8px;
    overflow: hidden;

    thead th {
        background: #f8f9fa;
        border: none;
        font-weight: 600;
        font-size: 12px;
        text-transform: uppercase;
        color: #666;
        padding: 12px 15px;
    }

    tbody td {
        padding: 15px;
        vertical-align: middle;
        border-bottom: 1px solid #f0f0f0;
    }

    tbody tr:hover {
        background-color: #f8f9ff;
    }
}

// Action Buttons
.action-buttons {
    display: flex;
    gap: 8px;
}

.action-btn {
    width: 32px;
    height: 32px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.action-btn-details {
    background: #f0f0f0;
    color: #666;
    &:hover, &.active {
        background: #7367f0;
        color: white;
    }
}

.action-btn-print {
    background: #e8f4fd;
    color: #2196f3;
    &:hover {
        background: #2196f3;
        color: white;
    }
}

.action-btn-copy {
    background: #e6f7f1;
    color: #10b981;
    &:hover {
        background: #10b981;
        color: white;
    }
}

.action-btn-delete {
    background: #fdeaea;
    color: #e74c3c;
    &:hover {
        background: #e74c3c;
        color: white;
    }
}

.action-btn-history {
    background: #e8f8f5;
    color: #1abc9c;
    &:hover {
        background: #1abc9c;
        color: white;
    }
}

.action-btn-albaran {
    background: #fff3e0;
    color: #ff9800;
    &:hover {
        background: #ff9800;
        color: white;
    }
}

// Codigo y Fecha
.codigo-pedido {
    font-weight: 600;
    color: #333;
}

.company-cell {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 6px;
}
.company-cell .company-pedido {
    font-weight: 500;
    color: #333;
}
.company-cell .company-add {
    font-size: 12px;
}
.company-cell .company-edit-icon {
    font-size: 11px;
    color: #b0b0b0;
    opacity: 0;
    transition: opacity 0.15s;
}
.company-cell:hover .company-edit-icon {
    opacity: 1;
}

.action-btn-comment.has-comments {
    color: #f0a020;
}

.fecha-pedido {
    color: #666;
    font-size: 13px;
}

// Estado Badge
.estado-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 500;
}

.estado-terminado {
    background: #d4edda;
    color: #155724;
}

.estado-proceso {
    background: #fff3cd;
    color: #856404;
}

.estado-pendiente {
    background: #f0f0f0;
    color: #666;
}

// Details Card
.details-card {
    background: #fafbfc;
    border-radius: 8px;
    padding: 15px;
    margin: 10px 0;
}

.details-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 15px;

    h6 {
        margin: 0;
        color: #333;
        font-weight: 600;
    }
}

.items-count {
    background: #7367f0;
    color: white;
    padding: 3px 10px;
    border-radius: 12px;
    font-size: 11px;
}

// Table Detalle
.table-detalle {
    background: white;
    border-radius: 6px;

    thead th {
        font-size: 11px;
        color: #888;
        font-weight: 500;
        padding: 10px;
    }

    tbody td {
        padding: 12px 10px;
    }
}

// Tabla con columnas de colores
.table-detalle-colores {
    background: white;
    border-radius: 6px;
    font-size: 0.8rem;
    min-width: 100%;

    thead th {
        font-size: 11px;
        font-weight: 600;
        text-align: center;
        background: #f8f9fa;
        padding: 8px 4px;
    }

    tbody td {
        padding: 6px 4px;
        vertical-align: middle;
        text-align: center;
    }

    tbody td:first-child {
        text-align: left;
        padding-left: 10px;
    }
}

.cell-color {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
}

.color-total {
    font-weight: 700;
    font-size: 14px;
    color: #333;
    cursor: pointer;
    position: relative;

    .edit-icon-hint {
        font-size: 8px;
        color: #ccc;
        margin-left: 3px;
    }

    &.editing {
        cursor: default;
    }
}

.input-cantidad-edit {
    width: 55px !important;
    text-align: center;
    padding: 2px 4px;
    font-size: 13px;
    font-weight: 700;
}

.estado-pendiente-icon {
    color: #ddd;
    font-size: 14px;
    transition: color 0.2s;
    &:hover {
        color: #28a745;
    }
}

.color-progreso {
    display: flex;
    gap: 6px;
    font-size: 10px;
}

.progreso-corte-mini {
    color: #17a2b8;
    i { margin-right: 2px; }
}

.progreso-mano-mini {
    color: #fd7e14;
    i { margin-right: 2px; }
}

.color-estado {
    font-size: 12px;
}

.color-delete {
    margin-top: 2px;
}

.action-btn-delete-item {
    width: 18px;
    height: 18px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    cursor: pointer;
    font-size: 10px;
    color: #ccc;
    transition: all 0.2s ease;
    &:hover {
        background: #e74c3c;
        color: white;
    }
}

.sku-cell {
    display: flex;
    flex-direction: column;
}

.sku-name {
    font-weight: 500;
    color: #333;
}

.sku-code {
    font-size: 11px;
    color: #999;
}

.cantidad-total {
    font-weight: 600;
    color: #333;
    font-size: 14px;
}

// Progreso
.progreso-section {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.progreso-item {
    display: flex;
    align-items: center;
    gap: 8px;
}

.progreso-label {
    font-size: 11px;
    color: #888;
    width: 50px;
}

.progreso-bar-container {
    flex: 1;
    height: 6px;
    background: #e9ecef;
    border-radius: 3px;
    overflow: hidden;
}

.progreso-bar {
    height: 100%;
    border-radius: 3px;
    transition: width 0.3s ease;
}

.progreso-corte {
    background: linear-gradient(90deg, #17a2b8, #20c997);
}

.progreso-aparado {
    background: linear-gradient(90deg, #ffc107, #fd7e14);
}

.progreso-text {
    font-size: 11px;
    color: #666;
    min-width: 45px;
    text-align: right;
}

// Estado Item
.estado-item {
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-size: 14px;
}

.estado-item.completado {
    background: #d4edda;
    color: #28a745;
}

.estado-item.pendiente {
    background: #fff3cd;
    color: #ffc107;
}

// Modal
.buscar-historial {
    max-width: 260px;
}

.modal-header-custom {
    display: flex;
    align-items: center;
    gap: 15px;
    width: 100%;

    h5 {
        margin: 0;
        font-weight: 600;
    }
}

.sku-badge {
    background: #f0f0f0;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 12px;
    color: #666;
}

.table-historial {
    thead th {
        font-size: 12px;
        font-weight: 600;
    }
}

.fecha-historial {
    color: #666;
    font-size: 13px;
}

.seccion-badge {
    padding: 4px 10px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
}

.seccion-corte {
    background: #e8f4fd;
    color: #17a2b8;
}

.seccion-aparado {
    background: #fff8e6;
    color: #fd7e14;
}

.incremento {
    color: #28a745;
    font-weight: 600;
}

.empty-historial {
    text-align: center;
    padding: 40px;
    color: #999;

    i {
        font-size: 40px;
        margin-bottom: 10px;
    }

    p {
        margin: 0;
    }
}

// Modal Albarán
.codigo-badge {
    background: #ff9800;
    color: white;
    padding: 4px 12px;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 600;
}

.albaran-info {
    padding: 10px;
    background: #f8f9fa;
    border-radius: 6px;
}

.table-albaran {
    thead th {
        font-size: 12px;
        font-weight: 600;
        background: #f8f9fa;
    }

    tbody td {
        vertical-align: middle;
    }
}

.disponible-badge {
    background: #d4edda;
    color: #155724;
    padding: 3px 8px;
    border-radius: 4px;
    font-weight: 600;
}

.input-cantidad {
    width: 100px !important;
    text-align: center;
}

.modal-footer-custom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.resumen-envio {
    font-size: 13px;
    color: #666;
    font-weight: 500;
}

.footer-buttons {
    display: flex;
    gap: 8px;
}

</style>

<style lang="scss">
.dark-layout {
    .header-section {
        border-bottom-color: #333;
    }

    .header-title {
        color: #d0d2d6;
    }

    .search-input {
        border-color: #333;
    }

    .table-pedidos {
        thead th {
            background: #2e2e2e !important;
            color: #b4b7bd;
        }
        tbody td {
            border-bottom-color: #333;
        }
        tbody tr:hover {
            background-color: #2e2e2e !important;
        }
    }

    .action-btn-details {
        background: #333;
        color: #b4b7bd;
    }

    .action-btn-print {
        background: #1a2a33;
        color: #2196f3;
    }

    .action-btn-copy {
        background: #1a332a;
        color: #10b981;
    }

    .action-btn-delete {
        background: #3a1e1e;
        color: #e74c3c;
    }

    .action-btn-albaran {
        background: #3a2e1e;
        color: #ff9800;
    }

    .codigo-pedido {
        color: #d0d2d6;
    }

    .fecha-pedido {
        color: #b4b7bd;
    }

    .estado-pendiente {
        background: #333;
        color: #b4b7bd;
    }

    .estado-terminado {
        background: #1e3a2a;
        color: #28a745;
    }

    .estado-proceso {
        background: #3a2e1e;
        color: #ffc107;
    }

    .details-card {
        background: #242424;
    }

    .details-header h6 {
        color: #d0d2d6;
    }

    .table-detalle,
    .table-detalle-colores {
        background: #242424;

        thead th {
            background: #2e2e2e !important;
            color: #b4b7bd;
        }
    }

    .sku-name,
    .cantidad-total,
    .color-total {
        color: #d0d2d6;
    }

    .sku-badge {
        background: #333;
        color: #b4b7bd;
    }

    .albaran-info {
        background: #242424;
    }

    .table-albaran thead th {
        background: #2e2e2e !important;
    }

    .disponible-badge {
        background: #1e3a2a;
        color: #28a745;
    }

    .progreso-bar-container {
        background: #333;
    }

    .progreso-text {
        color: #b4b7bd;
    }

    .resumen-envio {
        color: #b4b7bd;
    }

    .estado-item.completado {
        background: #1e3a2a;
    }

    .estado-item.pendiente {
        background: #3a2e1e;
    }
}
</style>

<style lang="scss">
@import './pv-base.scss';

.pv {

  .codigo-pedido {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    font-weight: 700;
    color: $pv-ink;
    letter-spacing: 0.02em;
  }

  // Fecha cell (date + relative)
  .fecha-cell {
    display: flex;
    flex-direction: column;
    gap: 2px;
    line-height: 1.25;
  }

  .fecha-pedido {
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    color: $pv-text;
    font-weight: 600;
    font-feature-settings: "tnum";
  }

  .fecha-relativa {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 10px;
    font-weight: 600;
    text-transform: lowercase;
    letter-spacing: 0.02em;

    &.age-fresh { color: $pv-emerald; }
    &.age-warn  { color: $pv-amber; }
    &.age-stale { color: $pv-coral; }
  }

  // Refs pill
  .refs-pill {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 10px;
    background: rgba(59, 130, 246, 0.10);
    color: $pv-primary;
    border-radius: 999px;
    font-family: 'JetBrains Mono', monospace;
    font-size: 12px;
    font-weight: 700;
    font-feature-settings: "tnum";

    i { font-size: 10px; }
  }

  // Total uds
  .total-uds {
    display: inline-flex;
    align-items: baseline;
    gap: 4px;
    font-family: 'JetBrains Mono', monospace;
    font-feature-settings: "tnum";

    strong {
      font-size: 16px;
      font-weight: 700;
      color: $pv-ink;
    }
    span {
      font-size: 10px;
      font-weight: 600;
      color: $pv-soft;
      text-transform: uppercase;
      letter-spacing: 0.06em;
    }

    &--ok strong { color: $pv-emerald !important; }
    &--warn strong { color: $pv-amber !important; }
  }

  // Progress cell
  .prog-cell {
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 230px;
  }

  .prog-row {
    display: flex;
    align-items: center;
    gap: 8px;
    font-family: 'Plus Jakarta Sans', sans-serif;
  }

  .prog-label {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    font-family: 'JetBrains Mono', monospace;
    font-size: 9px;
    font-weight: 700;
    color: $pv-soft;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    width: 50px;
    flex-shrink: 0;

    i { font-size: 8px; }
  }

  .prog-bar {
    flex: 1;
    height: 6px;
    background: $pv-surface-2;
    border-radius: 999px;
    overflow: hidden;
    min-width: 80px;

    &--corte .prog-bar-fill { background: $pv-cta; }
    &--mano  .prog-bar-fill { background: $pv-emerald; }
    &--albaran .prog-bar-fill { background: $pv-primary; }
  }

  .prog-bar-fill {
    height: 100%;
    border-radius: 999px;
    transition: width 300ms ease;
  }

  .prog-pct {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 700;
    color: $pv-ink;
    width: 32px;
    text-align: right;
    font-feature-settings: "tnum";
  }

  // Estado badge
  .estado-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    padding: 4px 10px;
    border-radius: 999px;

    i { font-size: 9px; }

    &.estado-pendiente {
      background: rgba(245, 158, 11, 0.12);
      color: darken($pv-amber, 8%);
    }
    &.estado-en-progreso, &.estado-en-proceso {
      background: rgba(59, 130, 246, 0.12);
      color: $pv-primary;
    }
    &.estado-completado, &.estado-terminado, &.estado-finalizado {
      background: rgba(16, 185, 129, 0.12);
      color: $pv-emerald;
    }
    &.estado-cancelado {
      background: rgba(239, 68, 68, 0.12);
      color: $pv-coral;
    }
  }

  // ──────────── ACTION BUTTONS ────────────
  .action-buttons {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }

  .action-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 30px;
    height: 30px;
    border: 1px solid $pv-border;
    background: $pv-surface;
    border-radius: 8px;
    color: $pv-mute;
    cursor: pointer;
    transition: all 150ms ease;
    font-size: 11px;

    &:hover { background: $pv-surface-2; color: $pv-ink; border-color: $pv-soft; }

    &.action-btn-details.active {
      background: rgba(59, 130, 246, 0.1);
      color: $pv-primary;
      border-color: rgba(59, 130, 246, 0.25);
    }
    &.action-btn-print {
      background: rgba(59, 130, 246, 0.08);
      color: $pv-primary;
      border-color: rgba(59, 130, 246, 0.25);

      &:hover {
        background: $pv-primary;
        color: #fff;
        border-color: $pv-primary;
        box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
      }
    }
    &.action-btn-copy {
      background: rgba(16, 185, 129, 0.08);
      color: #10b981;
      border-color: rgba(16, 185, 129, 0.25);

      &:hover {
        background: #10b981;
        color: #fff;
        border-color: #10b981;
        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);
      }
    }
    &.action-btn-albaran {
      background: rgba(249, 115, 22, 0.08);
      color: $pv-cta;
      border-color: rgba(249, 115, 22, 0.25);

      &:hover {
        background: $pv-cta;
        color: #fff;
        border-color: $pv-cta;
        box-shadow: 0 4px 12px rgba(249, 115, 22, 0.25);
      }

      &.is-disabled,
      &.is-disabled:hover {
        background: transparent;
        color: $pv-soft;
        border-color: $pv-border;
        box-shadow: none;
        opacity: 0.6;
        cursor: not-allowed;
      }
    }
    &.action-btn-delete {
      &:hover { background: rgba(239, 68, 68, 0.06); color: $pv-coral; border-color: $pv-coral; }
    }
  }

  // ──────────── DETAILS CARD (row-details) ────────────
  ::v-deep .b-table-details > td {
    padding: 0 !important;
  }

  .details-card {
    background: $pv-surface-2;
    border-top: 1px solid $pv-border;
    padding: 16px 20px 18px;
    overflow-x: auto;
  }

  .details-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;

    h6 {
      font-family: 'Plus Jakarta Sans', sans-serif;
      font-size: 12px;
      font-weight: 700;
      color: $pv-ink;
      margin: 0;
      letter-spacing: -0.01em;

      i { color: $pv-primary; margin-right: 4px; }
    }

    .items-count {
      font-family: 'JetBrains Mono', monospace;
      font-size: 11px;
      font-weight: 600;
      color: $pv-primary;
      background: rgba(59, 130, 246, 0.1);
      padding: 3px 9px;
      border-radius: 6px;
    }
  }

  .details-table-wrapper {
    background: $pv-surface;
    border: 1px solid $pv-border;
    border-radius: 10px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;

    .table-detalle-colores {
      min-width: 900px;
    }
  }

  .table-detalle-colores {
    margin-bottom: 0;
    font-size: 12px;

    thead th {
      background: $pv-bg !important;
      border-bottom: 1px solid $pv-border !important;
      padding: 7px 10px !important;
      font-size: 10px !important;
    }

    tbody tr {
      border-bottom: 1px solid $pv-divider;
      &:last-child { border-bottom: 0; }
      &:hover { background: rgba(59, 130, 246, 0.03) !important; }
    }

    td {
      padding: 4px 10px !important;
      border-top: 0 !important;
      vertical-align: middle;
      line-height: 1.2;
    }
  }

  // SKU cell
  .sku-cell {
    display: flex;
    flex-direction: column;
    gap: 2px;
    line-height: 1.3;
    min-width: 0;
  }
  .sku-name {
    font-family: 'Plus Jakarta Sans', sans-serif;
    font-size: 12px;
    font-weight: 600;
    color: $pv-ink;
  }
  .sku-code {
    font-family: 'JetBrains Mono', monospace;
    font-size: 10px;
    color: $pv-mute;
    letter-spacing: 0.02em;
  }

  // Color cell
  .cell-color {
    display: flex;
    flex-direction: column;
    gap: 1px;
    align-items: center;
    min-width: 70px;
    line-height: 1.2;
    padding: 4px 6px;
    border-radius: 6px;

    // Terminado en verde, pendiente en ámbar: se distinguen de un vistazo
    &.is-terminado {
      background: rgba($pv-emerald, 0.12);
    }
    &.is-pendiente {
      background: rgba($pv-amber, 0.12);
    }

    // SKU que coincide con la búsqueda
    &.sku-match {
      background: rgba($pv-primary, 0.12);
      box-shadow: 0 0 0 2px $pv-primary;
      border-radius: 6px;
    }
  }

  .color-total {
    font-family: 'JetBrains Mono', monospace;
    font-size: 13px;
    font-weight: 700;
    color: $pv-ink;
    cursor: pointer;
    padding: 0 6px;
    border-radius: 4px;
    transition: all 150ms ease;
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    line-height: 1.4;

    .edit-icon-hint {
      position: absolute;
      right: -10px;
      top: 50%;
      transform: translateY(-50%);
      font-size: 8px;
      color: $pv-soft;
      opacity: 0;
      transition: opacity 150ms ease;
      pointer-events: none;
    }

    &:hover {
      background: rgba(59, 130, 246, 0.08);
      color: $pv-primary;
      .edit-icon-hint { opacity: 1; }
    }

    &.editing {
      padding: 0;
      background: transparent;
    }
  }

  .input-cantidad-edit {
    width: 56px !important;
    height: 22px !important;
    padding: 0 6px !important;
    background: $pv-surface !important;
    border: 1px solid $pv-primary !important;
    border-radius: 4px !important;
    font-family: 'JetBrains Mono', monospace !important;
    font-size: 12px !important;
    font-weight: 700 !important;
    color: $pv-ink !important;
    text-align: center !important;
    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12) !important;
  }

  .color-progreso {
    display: flex;
    gap: 5px;
    font-family: 'JetBrains Mono', monospace;
    font-size: 9px;
    font-weight: 600;
    line-height: 1.2;
  }

  .progreso-corte-mini {
    color: $pv-cta;
    display: inline-flex;
    align-items: center;
    gap: 2px;
    i { font-size: 8px; }
  }

  .progreso-mano-mini {
    color: $pv-emerald;
    display: inline-flex;
    align-items: center;
    gap: 2px;
    i { font-size: 8px; }
  }

  .color-estado {
    font-size: 12px;
    line-height: 1;
    .text-success { color: $pv-emerald !important; }
    .estado-pendiente-icon { color: $pv-soft; }
    &:hover .estado-pendiente-icon { color: $pv-primary; }
  }

  .color-delete {
    line-height: 1;

    .action-btn-delete-item {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 14px;
      height: 14px;
      border-radius: 50%;
      color: $pv-soft;
      cursor: pointer;
      font-size: 9px;
      transition: all 150ms ease;

      &:hover { background: $pv-coral; color: #fff; }
    }
  }

  @keyframes pv-pulse {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.55; transform: scale(0.85); }
  }

  @media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
      animation-duration: 0.01ms !important;
      transition-duration: 0.01ms !important;
    }
  }
}

// ══════════ DARK MODE ══════════
.dark-layout .pv {
  background: #161616;
  color: #d0d2d6;

  .pv-dash-header,
  .pv-card { background: #1f1f1f; border-color: #2c2c2c; box-shadow: none; }
  .pv-title { color: #e4e6eb; }
  .pv-card-title { color: #e4e6eb; }
  .pv-card-head { border-bottom-color: #2c2c2c; }
  .pv-stat-pill { background: #161616; border-color: #2c2c2c; }
  .pv-stat-pill strong { color: #e4e6eb; }
  .pv-kpi { background: #161616; border-color: #2c2c2c; }
  .pv-kpi-value strong { color: #e4e6eb; }

  .pv-search input { background: #161616; border-color: #2c2c2c; color: #d0d2d6; &:focus { background: #242424; } }

  .pv-btn { background: #1f1f1f; border-color: #2c2c2c; color: #d0d2d6; }
  .pv-btn--ghost:hover { background: #242424; }

  .table { background: #1f1f1f !important; }
  .table thead th { background: #1f1f1f !important; color: #6e7079 !important; border-bottom-color: #2c2c2c !important; }
  .table tbody tr { background: #1f1f1f !important; }
  .table tbody tr td { border-top-color: #2c2c2c !important; color: #d0d2d6 !important; }
  .table tbody tr:hover { background: #242424 !important; }

  .codigo-pedido { color: #e4e6eb; }
  .company-cell .company-pedido { color: #e4e6eb; }
  .fecha-pedido { color: #e4e6eb; }
  .total-uds strong { color: #e4e6eb; }
  .prog-pct { color: #e4e6eb; }
  .prog-bar { background: #2c2c2c; }
  .sku-name { color: #e4e6eb; }
  .color-total { color: #e4e6eb; }

  .details-card { background: #161616; border-top-color: #2c2c2c; }
  .details-table-wrapper { background: #1f1f1f; border-color: #2c2c2c; }
  .table-detalle-colores thead th { background: #161616 !important; }

  // Los botones de color (print/copy/albarán) mantienen sus tintes rgba, que ya funcionan en oscuro
  .action-btn:not(.action-btn-print):not(.action-btn-copy):not(.action-btn-albaran) {
    background: #1f1f1f; border-color: #2c2c2c; color: #8e9099;
    &:hover { background: #242424; color: #e4e6eb; border-color: #3a3a3a; }
  }
  .action-btn.action-btn-albaran.is-disabled,
  .action-btn.action-btn-albaran.is-disabled:hover { background: transparent; color: #5a5c63; border-color: #2c2c2c; }
}

// Aviso de cantidad por encima de lo disponible (modal albarán)
.input-excedido,
.input-excedido:focus {
    border-color: #F59E0B !important;
    box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.15) !important;
}
.aviso-excedido {
    display: block;
    margin-top: 4px;
    font-size: 11px;
    font-weight: 600;
    color: #D97706;
}
</style>
